import React from "react";
import UserTable from "../user-table";
import { AccountCards } from "../../../components/cards/account-card";

const Merchant = ({
  data,
  statistics,
  selectedStatus,
  handleStatusChange,
  activeTab,
  handleDateRangeChange,
  startDate,
  endDate,
  loading,
  handleResetFilters
}: any) => {
  return (
    <div>
      <AccountCards statistics={statistics} />
      <UserTable
        data={data}
        selectedStatus={selectedStatus}
        handleStatusChange={handleStatusChange}
        activeTab={activeTab}
        startDate={startDate}
        endDate={endDate}
        handleDateRangeChange={handleDateRangeChange}
        handleResetFilters={handleResetFilters}
        loading={loading}
      />
    </div>
  );
};

export default Merchant;
